import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import convertDataAttributes from '@widgets/shared/convertDataAttributes';
import { FormProvider, useForm, } from 'react-hook-form';
import { useCallback, useState } from 'react';
import { resetPasswordFormSchema } from '@widgets/ResetPasswordForm/validation/schema';
import { yupResolver } from '@hookform/resolvers/yup';
import { useRef } from 'preact/compat';
import TextInput from '@widgets/shared/components/form-controls/TextInput';
import API from '@widgets/shared/API/connection';
import FormNotices from '@widgets/shared/components/FormNotices';
function Form(props) {
    const formRef = useRef(null);
    const [errorMessage, setErrorMessage] = useState(undefined);
    const [isRequesting, setIsRequesting] = useState(false);
    const { title, successUrl: successUrlOverride, buttonText, headingSize, } = props;
    const form = useForm({
        mode: 'onChange',
        resolver: yupResolver(resetPasswordFormSchema),
        defaultValues: {
            password: '',
            confirmPassword: '',
        },
    });
    const { getValues, handleSubmit, setError, formState: { isValid, errors }, } = form;
    const handleNoticeClose = useCallback(() => {
        setErrorMessage(undefined);
    }, []);
    const handleSubmitEvent = () => {
        setIsRequesting(true);
        const values = getValues();
        const formEl = formRef.current;
        API.resetPassword(values).then((res) => {
            if (res.success) {
                window.location.href = successUrlOverride ?? res.successUrl ?? '';
            }
            else {
                res.errors.forEach((error) => {
                    if (error.field) {
                        setError(error.field, { message: error.message }, {
                            shouldFocus: true,
                        });
                    }
                });
                if (res.message) {
                    setErrorMessage(res.message);
                }
            }
        })
            .finally(() => {
            setIsRequesting(false);
        });
    };
    return (_jsx(FormProvider, { ...form, children: _jsxs("form", { method: "POST", ref: formRef, onSubmit: handleSubmit(handleSubmitEvent), noValidate: true, className: "form form--login", children: [errorMessage && (_jsx("div", { style: { marginBottom: '1rem' }, children: _jsx(FormNotices, { message: errorMessage, type: "error", handleClose: handleNoticeClose }) })), _jsx("div", { className: "form__content", children: _jsx("h2", { className: headingSize, children: title }) }), _jsx(TextInput, { inputAttrs: {
                        id: 'password',
                        name: 'password',
                        type: 'password',
                    }, labelAttrs: {
                        htmlFor: 'password',
                        text: 'New Password',
                        isFieldRequired: false, // it is but hiding asterix
                    } }), _jsx(TextInput, { inputAttrs: {
                        id: 'confirm-password',
                        name: 'confirmPassword',
                        type: 'password',
                    }, labelAttrs: {
                        htmlFor: 'confirm-password',
                        text: 'Confirm New Password',
                        isFieldRequired: false, // it is but hiding asterix
                    } }), _jsx("div", { className: "form__actions", children: _jsx("button", { type: "submit", className: "btn", disabled: !isValid || isRequesting, children: buttonText ?? 'Reset Password' }) })] }) }));
}
function ResetPasswordForm(props) {
    const { dataset } = props;
    const formConfig = convertDataAttributes(dataset ?? {});
    return (_jsx(Form, { ...formConfig }));
}
export default ResetPasswordForm;
